import { StyledMainProduct } from './style';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

interface IBabaMainProductProps {
  quantityDisplay?: string;
  strokedSaleQuantity?: string;
  image?: string;
  salePercentage?: number;
}

export const BabaMainProduct: React.FC<IBabaMainProductProps> = ({
  quantityDisplay = '0',
  strokedSaleQuantity,
  image = '',
  salePercentage = 0,
}) => {
  return (
    <StyledMainProduct title={quantityDisplay}>
      <div className="image-wrapper">
        {image && <img src={image} className="mainPic" alt="main product" />}
      </div>
      <div className={'stroked-wrapper'}>
        {salePercentage > 0 && (
          <AutoTextSize
            maxFontSizePx={14}
            minFontSizePx={6}
            as="div"
            mode="oneline"
            className="stroked"
          >
            {strokedSaleQuantity}
          </AutoTextSize>
        )}
      </div>
      <div className={'quantity-wrapper'}>
        <AutoTextSize
          maxFontSizePx={18}
          minFontSizePx={6}
          as="div"
          className="quantity"
          mode="oneline"
        >
          {quantityDisplay}
        </AutoTextSize>
      </div>
    </StyledMainProduct>
  );
};
